import { fleetManagementApi } from "../api";

export const uploadMedia = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fleetManagementApi.post("/media", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
}

export const deleteMedia = async ({filename}) => {
  const response = await fleetManagementApi.delete(`/media/${filename}`);
  return response;
}